import script from "./TreeSelectField.vue?vue&type=script&setup=true&lang=ts"
export * from "./TreeSelectField.vue?vue&type=script&setup=true&lang=ts"

import "./TreeSelectField.vue?vue&type=style&index=0&id=e8b06fa4&lang=scss"

const __exports__ = script;

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTree from 'quasar/src/components/tree/QTree.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTree});
